import request from '../../utils/request';

const SystemInformationService = {
  search: (search: any) => {
    return request('/systemInformation/informations', {
      method: 'POST',
      body: JSON.stringify({ request: { ...search } }),
    });
  },

  // upsert: (
  //   /** @type {any} */ id: any,
  //   formData: {
  //     id: any;
  //     name: any;
  //     category: any;
  //     categoryId: any;
  //     price: any;
  //     description: any;
  //     manufacturer: any;
  //     productId: any;
  //     stock: any;
  //     imageLink: any;
  //     version: any;
  //   }
  // ) => {
  //   return request('/deviceInformation/upsert', {
  //     method: 'POST',
  //     body: JSON.stringify({
  //       request: {
  //         id: id,
  //         name: formData.name,
  //         category: formData.category,
  //         categoryId: formData.categoryId,
  //         price: formData.price,
  //         description: formData.description,
  //         manufacturer: formData.manufacturer,
  //         productId: formData.productId,
  //         stock: formData.stock,
  //         imageLink: formData.imageLink,
  //         version: formData.version,
  //       },
  //     }),
  //   });
  // },
};

export default SystemInformationService;
